import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })

export class RegexService {

    constructor() { }

    public nameRegex() {
        return /^[\s]*[a-zA-ZÀ-ÿ]+(([’'. -][a-zA-ZÀ-ÿ ])?[a-zA-ZÀ-ÿ]*)*[\s]*$/;
    }  

    public companyRegex() {
    
        return /^[\s]*[a-zA-ZÀ-ÿ]+(([\s]?[’'.&'-`. \s][a-zA-ZÀ-ÿ ])?[a-zA-ZÀ-ÿ]*)*[\s]*$/;
    }

    public emailRegex() {
        return "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,63}?$";
    }
    
    public passwordRegex() {
        return /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;
    }

}
